module.exports = __webpack_public_path__ + "media/images/resource/1mbb-431f4a02738cd187a36ae7d54d64bade.png";